interface IconProps {
  size?: number;
  className?: string;
}

/**
 * Depicts the "islands" / dashboard-cards layout: a header strip across the top
 * with a grid of free-floating content cards below (no left rail).
 */
export function LayoutCardsIcon({ size = 18, className }: IconProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={1.75}
      strokeLinecap="round"
      strokeLinejoin="round"
      className={className}
      aria-hidden="true"
    >
      <rect x="3" y="4" width="18" height="16" rx="2" />
      <path d="M3 8h18" />
      <rect x="5.5" y="10.5" width="5.5" height="3.25" rx="0.7" />
      <rect x="13" y="10.5" width="5.5" height="3.25" rx="0.7" />
      <rect x="5.5" y="15.25" width="5.5" height="2.75" rx="0.7" />
      <rect x="13" y="15.25" width="5.5" height="2.75" rx="0.7" />
    </svg>
  );
}

/**
 * Depicts the "sidebar" layout: a left navigation rail with stacked menu items
 * and a content column to the right.
 */
export function LayoutSidebarIcon({ size = 18, className }: IconProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={1.75}
      strokeLinecap="round"
      strokeLinejoin="round"
      className={className}
      aria-hidden="true"
    >
      <rect x="3" y="4" width="18" height="16" rx="2" />
      <path d="M9 4v16" />
      <path d="M5.5 8.5h2" />
      <path d="M5.5 12h2" />
      <path d="M5.5 15.5h2" />
      <path d="M12 8.5h6" />
      <path d="M12 12h6" />
      <path d="M12 15.5h3.5" />
    </svg>
  );
}
